export default {"src":"/_next/static/media/no-data.c45cd26c.svg","height":213,"width":240,"blurWidth":0,"blurHeight":0};